var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:'button--' + _vm.variant},[_c('router-link',{staticClass:"button-link",attrs:{"to":_vm.to}},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t\t"),_c('span')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }